export default __webpack_public_path__ + "static/media/no-image-available.2f31db8c.svg";